var map = {
	"./DP001C_001.png": "ea6b",
	"./DP001C_002.png": "a762",
	"./DP001C_003.png": "5c03",
	"./DP005C_001.png": "4969",
	"./DP005C_002.png": "0316",
	"./DP005E_001.png": "f369",
	"./DP011C_001.png": "9f1c",
	"./DP011C_002.png": "fd47",
	"./DP011E_001.png": "a4d3c",
	"./DP014.png": "6a75",
	"./DP014C_001.png": "35bf",
	"./DP014_001.png": "e069",
	"./DP014_002.png": "330a",
	"./MANGO_PCB.png": "ccd7",
	"./SHELLS.png": "01cc",
	"./unknown_cr.png": "38e2",
	"./unknown_eb.png": "083a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eedf";